interface Props {
    children: React.ReactNode
}

export default function PageTitle({ children }: Props) {
    return <h1 className="mt-8 text-3xl lg:text-4xl dark:text-white">{children}</h1>
}
